<template>
  <div class="header-bar-wrapper" :class="{ 'fold-active': isFold }">

    <div class="button" @click="folding"
         :style="{ backgroundImage: `url(${HamburgerButton})` }"></div>

    <div class="title-wrapper">
      <p class="title">{{ title }}</p>
    </div>

  </div>
</template>

<script>
import SidebarConfig from '@/configs/sidebar';
import HamburgerButton from '@/assets/icons/hamburger_button.svg';

export default {
  name: 'HeaderBar',
  props: {
    customTitle: {
      type: String,
      default: null,
    },
    isFold: {
      type: Boolean,
    },
  },
  computed: {
    location() {
      return this.$route.name;
    },

    title() {
      if (this.customTitle) return this.customTitle;
      return this.getLocationTitle(this.location.toLowerCase());
    },
  },
  methods: {
    getLocationTitle(target) {
      const result = this.findName(target, this.SidebarConfig());

      return result;
    },

    findName(target, array) {
      return this.recursiveFindNameInChildren(target, array);
    },

    recursiveFindNameInChildren(target, arr) {
      if (arr === undefined || arr === null) return null;

      for (let i = 0; i < arr.length; i += 1) {
        if (arr[i].pageName === target) return arr[i].name;

        const result = this.recursiveFindNameInChildren(target, arr[i].children);

        if (result !== null) return result;
      }

      return null;
    },

    folding() {
      this.$store.commit('folding');
    },
  },
  data() {
    return {
      SidebarConfig,
      HamburgerButton,
    };
  },
};
</script>

<style lang="scss" scoped>
.header-bar-wrapper {
  width: calc(100vw - 220px);
  height: 60px;

  transition: width ease-in-out 0.5s;

  background-color: rgb(255, 255, 255);

  display: flex;
  justify-content: flex-start;
  align-content: center;
  align-items: center;

  padding-left: 30px;

  .button {
    width: 32px;
    height: 32px;

    background-repeat: no-repeat;
    background-size: cover;
    background-position: center;

    cursor: pointer;
  }

  .title-wrapper {
    margin-left: 15px;

    .title {
      font-weight: 500;
      font-size: 20px;
    }
  }
}

.fold-active {
  width: 100vw;
}

@media screen and (max-width: 1024px) {
  .header-bar-wrapper {
    position: fixed;
    z-index: 50;

    width: 100%;

    padding-left: 12px;
  }
}
</style>



// WEBPACK FOOTER //
// src/spa/components/page-template/header/HeaderBar.vue